import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import { getAssetUrlInWorker } from '@wix/wix-data-client-common'
import type { EditorSDK, I18n } from '@wix/wix-data-client-common-standalone'

interface Params {
  editorSdkProxy: EditorSDK
  componentRef: ComponentRef
  newValue: boolean
  i18n: I18n
}
export async function setShowOnAllPages({
  editorSdkProxy,
  componentRef,
  newValue,
  i18n,
}: Params): Promise<{ newValue: boolean } | undefined> {
  if (newValue === true) {
    await editorSdkProxy.controllers.moveAppControllerToMasterPage({
      controllerRef: componentRef,
    })
    return { newValue }
  }

  const [currentPage, compRefs] = await Promise.all([
    editorSdkProxy.pages.getCurrent(),
    editorSdkProxy.document.controllers.listConnectedComponents({
      controllerRef: componentRef,
    }),
  ])
  const componentPages = await Promise.all(
    compRefs.map(componentRef =>
      editorSdkProxy.document.components.getPage({ componentRef }),
    ),
  )
  const hasConnectionsOnOtherPages = componentPages.some(
    pageRef => pageRef.id !== currentPage.id,
  )
  if (!hasConnectionsOnOtherPages) {
    await editorSdkProxy.controllers.moveAppControllerToPage({
      controllerRef: componentRef,
      pageRef: currentPage,
    })
    return { newValue }
  }
  const result = await editorSdkProxy.editor.openErrorPanel({
    headerText: i18n.t('Dataset_Type_Change_Title'),
    illustration: await getAssetUrlInWorker(
      editorSdkProxy,
      'panel-icons/disconnect_warning.svg',
    ),
    shouldShowIllustration: true,
    topDescriptionText: i18n.t('Dataset_Type_Change_Description'),
    mainActionText: i18n.t('Dataset_Type_Change_Main_Action'),
  })

  if (result === 'mainActionClicked') {
    await editorSdkProxy.controllers.moveAppControllerToPage({
      controllerRef: componentRef,
      pageRef: currentPage,
    })
    return { newValue }
  }
  return
}
